"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationStatus;
(function (CommunicationStatus) {
    CommunicationStatus["Draft"] = "Draft";
    CommunicationStatus["Active"] = "Active";
    CommunicationStatus["Archived"] = "Archived";
})(CommunicationStatus = exports.CommunicationStatus || (exports.CommunicationStatus = {}));
//# sourceMappingURL=CommunicationStatus.js.map